import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://3esolarventures.com/backend/get_blogs.php")
      .then((response) => {
        setBlogs(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blogs:", error);
        setError("Failed to fetch blogs. Please try again later.");
        setLoading(false);
      });
  }, []);

  // Pass the entire blog object via state when navigating
  const handleReadMore = (blog) => {
    navigate(`/blogs/${blog.id}`, { state: { blog } });
  };

  return (
    <div className="bg-white text-gray-900">
      <Navbar />
      <main className="max-w-7xl mx-auto px-6 md:px-12 py-8 md:pt-30 pt-30">
        <h3 className="text-xl md:text-2xl font-semibold mb-6 text-center md:text-start">All Blog Posts</h3>
        
        {loading && <p>Loading blogs...</p>}
        {error && <p className="text-red-500">{error}</p>}

        {!loading && !error && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogs.map((blog) => (
              <div key={blog.id} className="bg-white shadow-md rounded-lg overflow-hidden">
                <img
                  src={blog.featured_image}
                  alt={blog.title}
                  className="w-full h-44 object-cover"
                />
                <div className="p-4">
                  <p className="text-xs text-gray-500 mb-1">
                    {new Date(blog.published_date).toLocaleDateString()}
                  </p>
                  <h4 className="text-lg font-semibold text-gray-800">{blog.title}</h4>
                  <p className="text-sm text-gray-600 mt-2">
                    {blog.content.length > 200
                      ? blog.content.substring(0, 200) + "..."
                      : blog.content}
                  </p>
                  <button
                    onClick={() => handleReadMore(blog)}
                    className="mt-4 text-blue-600 hover:underline text-sm font-medium"
                  >
                    Read more →
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;
